import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Activities from './components/Activities';
import ECarbon from './components/ECarbon';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1.6;
  }

  html {
    scroll-behavior: smooth;
  }
`;

function App() {
  return (
    <Router>
      <GlobalStyle />
      <Routes>
        <Route path="/about_byeongsuko" element={
          <>
            <Hero />
            <About />
            <Experience />
            <Projects />
            <Activities />
          </>
        } />
        <Route path="/info" element={<ECarbon />} />
        <Route path="/" element={<Navigate to="/info" replace />} />
        <Route path="*" element={<Navigate to="/info" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
